import { exportAgencyContractsToCSV } from "common/services/contracts.service";
import { exportAgencyLTAsToCSV } from "common/services/ltas.service";
import { exportAgencyContractorsToCSV } from "common/services/contractors.service";

export const agencyExportActions = {
  contracts: {
    resource: "contract",
    controller: "agency",
    filename: "Agency_Contracts_Export.csv",
    label: "Contracts",
    toastLabel: "contracts",
    exportCsv: exportAgencyContractsToCSV,
  },
  contractors: {
    resource: "contractor",
    controller: "agency",
    filename: "Agency_Contractors_Export.csv",
    label: "Contractors",
    toastLabel: "contractors",
    exportCsv: exportAgencyContractorsToCSV,
  },
  ltas: {
    resource: "lta",
    controller: "agency",
    filename: "Agency_LTAs_Export.csv",
    label: "LTAs",
    toastLabel: "LTAs",
    exportCsv: exportAgencyLTAsToCSV,
  },
};
